import { defineComponent } from 'vue'

type PickupDeliveryItem = {
    id: number,
    visible: boolean,
    position: number,
    slug: string,
    uuid: string,
    title: string
}

export default defineComponent({
  name: 'PickupDelivery',
  props: {
    list: {
      type: Array as () => PickupDeliveryItem[],
      default: () => []
    },
    errors: {
      type: Array as () => string[],
      default: () => []
    }
  },
  data() {  
    return {
      selected: null as PickupDeliveryItem | null,
    }
  },
  methods: {
    select(item: PickupDeliveryItem) {
      this.$emit('select-item', item)
    }
  },
})
